import { useState, useCallback } from "react";
import useLockBodyScroll from "./useLockBodyScroll";

const useModal = (initialMode = false) => {
    const [modalOpen, setModalOpen] = useState(initialMode);
    const toggle = useCallback(() => setModalOpen(status => !status), []);
    useLockBodyScroll({ opened: modalOpen });
    return [modalOpen, toggle];
};

export default useModal;
